import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import CalendarHeader from './CalendarHeader';
import MonthTable from './MonthTable';
import DateInput from 'rc-calendar/lib/date/DateInput';
import { getTimeConfig } from 'rc-calendar/lib/util/index';

const CalendarPart = createReactClass({
    propTypes: {
        prefixCls: PropTypes.string,
        value: PropTypes.any,
        hoverValue: PropTypes.any,
        selectedValue: PropTypes.any,
        direction: PropTypes.any,
        locale: PropTypes.any,
        showDateInput: PropTypes.bool,
        showTimePicker: PropTypes.bool,
        format: PropTypes.any,
        placeholder: PropTypes.any,
        disabledDate: PropTypes.any,
        timePicker: PropTypes.any,
        disabledTime: PropTypes.any,
        onInputSelect: PropTypes.func,
        timePickerDisabledTime: PropTypes.object,
        enableNext: PropTypes.any,
        enablePrev: PropTypes.any,
        clearIcon: PropTypes.node,
    },
    render() {
        const props = this.props;
        const {
            prefixCls,
            value,
            hoverValue,
            selectedValue,
            mode,
            direction,
            locale, format, placeholder,
            disabledDate, timePicker, disabledTime,
            timePickerDisabledTime, showTimePicker,
            onInputSelect, enablePrev, enableNext,
            clearIcon,
        } = props;
        const shouldShowTimePicker = showTimePicker && timePicker;
        const disabledTimeConfig = shouldShowTimePicker && disabledTime ?
            getTimeConfig(selectedValue, disabledTime) : null;
        const rangeClassName = `${prefixCls}-range`;
        const newProps = {
            locale,
            value,
            prefixCls,
            showTimePicker,
        };
        const index = direction === 'left' ? 0 : 1;
        const timePickerEle = shouldShowTimePicker &&
      React.cloneElement(timePicker, {
          showHour: true,
          showMinute: true,
          showSecond: true,
          ...timePicker.props,
          ...disabledTimeConfig,
          ...timePickerDisabledTime,
          onChange: onInputSelect,
          defaultOpenValue: value,
          value: selectedValue[index],
      });

        const dateInputElement = props.showDateInput &&
      <DateInput
          format={format}
          locale={locale}
          prefixCls={prefixCls}
          timePicker={timePicker}
          disabledDate={disabledDate}
          placeholder={placeholder}
          disabledTime={disabledTime}
          value={value}
          showClear={false}
          selectedValue={selectedValue[index]}
          onChange={onInputSelect}
          clearIcon={clearIcon}
      />;
        return (
            <div
                className={`${rangeClassName}-part ${rangeClassName}-${direction}`}
            >
                {dateInputElement}
                <div style={{ outline: 'none' }}>
                    <CalendarHeader
                        {...newProps}
                        mode={mode}
                        enableNext={enableNext}
                        enablePrev={enablePrev}
                        // onMonthHover={props.onDayHover}
                        // hoverMonthValue={selectedValue}
                        onValueChange={props.onValueChange}
                        onPanelChange={props.onPanelChange}
                        disabledMonth={props.disabledMonth}
                    />
                    {showTimePicker ? <div className={`${prefixCls}-time-picker`}>
                        <div className={`${prefixCls}-time-picker-panel`}>
                            {timePickerEle}
                        </div>
                    </div> : null}
                    <div className={`${prefixCls}-body`}>

                        <MonthTable
                            {...newProps}
                            prefixCls={`${prefixCls}-month-panel`}
                            selectedValue={selectedValue}
                            dateRender={props.dateRender}
                            onSelect={props.onSelect}
                            onMonthHover={props.onMonthHover}
                            hoverMonthValue={hoverValue}
                            disabledDate={disabledDate}
                            showWeekNumber={props.showWeekNumber}
                        />

                    </div>
                </div>
            </div>);
    },
});

export default CalendarPart;



// WEBPACK FOOTER //
// ./src/components/MonthRangePicker/MonthPart.js